import React from 'react';
import {isMobile} from 'react-device-detect';
import {Button} from 'reactstrap';


const PurchaseAdditionalPackageButtonComponent = (props) => {
  
    return (
        <Button color="link" type="button" className="purchase-additional-package-button" onClick = {props.onClick}>
            <span className="button-text">
               {props.text}    
            </span>
            <span className="arrow-icon"></span>  
        </Button>
    )
}


export default PurchaseAdditionalPackageButtonComponent;